import React from 'react';

/* eslint-disable max-len */
const testimonials = [{
  text: 'Thanks to Oneteam we have one central platform with which all employees in all 18 stores can communicate together. We love using Oneteam because it is an all-in-one employee platform. Onboarding, realtime schedules, and shift changes: it is all in there!',
  name: 'Eveline Burger',
  title: 'Communication specialist, Goedhart',
  image: '/static/images/testimonials/eveline_burger.png',
}, {
  text: 'Thanks to Oneteam we are fully in control with regards to our internal communications. With one click on a button, we can efficiently reach our 2.200 employees across 15 stores. We have way more clarity now. This would never have been possible with email and WhatsApp. An absolute necessity, espicially in those special times.',
  name: 'Anrico Maat',
  title: 'Maripaan Group (Jumbo)',
  image: '/static/images/testimonials/anrico.png',
}, {
  text: 'We chose Oneteam for the right combination of features. Internal communications and onboarding: It is all in there. Features such as the possibility to instantly view your schedule and change shifts add so much value to both managers and employees. They love using Oneteam.',
  name: 'Nathalie Thuijls',
  title: 'Communication specialist, Humphrey\'s Restaurants',
  image: '/static/images/testimonials/nathalie.png',
}];
/* eslint-enable max-len */

const SLIDE_MS = 6000;

/** The rotating customer quotes that were the whole right column of the old free-trial page. */
export const Testimonials = () => {
  const [sliderIndex, setIndex] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => setIndex((index) => (index === testimonials.length - 1 ? 0 : index + 1)), SLIDE_MS);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="FreeTrial__Slider">
      <div className="FreeTrial__Slider__Container">
        {testimonials.map((testimonial, i) => (
          <div
            key={testimonial.name}
            className={`FreeTrial__Slider__Slide${i === sliderIndex ? ' FreeTrial__Slider__Slide--active' : ''}`}
          >
            <div className="FreeTrial__Slider__Slide__Quote">
              “
              {testimonial.text}
              ”
            </div>
            <div className="FreeTrial__Slider__Slide__Author">
              <div className="FreeTrial__Slider__Slide__Author__Image">
                <img src={testimonial.image} alt={testimonial.name} />
              </div>
              <div>
                <h5>{testimonial.name}</h5>
                {testimonial.title}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div key={sliderIndex} className="FreeTrial__Slider__Progress" aria-hidden="true">
        <div className="FreeTrial__Slider__Progress__Bar" style={{ animationDuration: `${SLIDE_MS}ms` }} />
      </div>
      <div className="FreeTrial__Slider__Index">
        {testimonials.map((item, i) => (
          <div
            key={item.name}
            className={`FreeTrial__Slider__Index__Dot${i === sliderIndex ? ' FreeTrial__Slider__Index__Dot--active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};
